import { ReactNode } from 'react';
import Tag from 'antd/lib/tag';
import CheckCircleOutlined from '@ant-design/icons/lib/icons/CheckCircleOutlined';
import ClockCircleOutlined from '@ant-design/icons/lib/icons/ClockCircleOutlined';
import CloseCircleOutlined from '@ant-design/icons/lib/icons/CloseCircleOutlined';
import CloudDownloadOutlined from '@ant-design/icons/lib/icons/CloudDownloadOutlined';
import ExclamationCircleOutlined from '@ant-design/icons/lib/icons/ExclamationCircleOutlined';
import SyncOutlined from '@ant-design/icons/lib/icons/SyncOutlined';
import { BillProcessingStatus } from 'src/domain/customer-utility-bill/interface';
import { PROCESSING_STATUS_LABEL } from 'src/domain/customer-utility-bill/interface';

// Icons mirror antd's status-color conventions (success ✓, error ✕, warning !, processing ⟳) so each tag reads at a glance.
const PROCESSING_STATUS_VISUAL: Record<BillProcessingStatus, { color: string; icon: ReactNode }> = {
    [BillProcessingStatus.Pending]: { color: 'default', icon: <ClockCircleOutlined /> },
    [BillProcessingStatus.DownloadSuccess]: { color: 'default', icon: <CloudDownloadOutlined /> },
    [BillProcessingStatus.DownloadFailed]: { color: 'error', icon: <CloseCircleOutlined /> },
    [BillProcessingStatus.ReparseQueued]: { color: 'processing', icon: <ClockCircleOutlined /> },
    [BillProcessingStatus.ParsingInProgress]: { color: 'processing', icon: <SyncOutlined spin /> },
    [BillProcessingStatus.ParsingSuccess]: { color: 'success', icon: <CheckCircleOutlined /> },
    [BillProcessingStatus.ParsingFailed]: { color: 'error', icon: <CloseCircleOutlined /> },
    [BillProcessingStatus.ParsingNeedsReview]: { color: 'warning', icon: <ExclamationCircleOutlined /> },
};

const DEFAULT_STATUS_VISUAL = { color: 'default', icon: <ClockCircleOutlined /> };

// `suffix` is appended after the label (e.g. a "3 / 5" count in summary chips).
export const BillStatusTag = ({ status, suffix }: { status: BillProcessingStatus; suffix?: ReactNode }) => {
    const v = PROCESSING_STATUS_VISUAL[status] ?? DEFAULT_STATUS_VISUAL;
    return (
        <Tag color={v.color} icon={v.icon} style={{ margin: 0 }}>
            {PROCESSING_STATUS_LABEL[status] ?? status}
            {suffix}
        </Tag>
    );
};
